var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4587 15.1423L7.05717 9.14621C6.94678 9.05426 6.80766 9.00391 6.66399 9.00391C6.52032 9.00391 6.38119 9.05426 6.2708 9.14621L1.58942 12.5129",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2679 9.0067C11.3211 9.0067 10.5536 8.23918 10.5536 7.29241C10.5536 6.34564 11.3211 5.57812 12.2679 5.57812C13.2147 5.57812 13.9822 6.34564 13.9822 7.29241C13.9822 8.23918 13.2147 9.0067 12.2679 9.0067Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57153 13.9988V1.99881C1.57153 1.69571 1.69194 1.40502 1.90627 1.19069C2.1206 0.976362 2.41129 0.855954 2.71439 0.855954H6.93153C7.1926 0.848348 7.4484 0.930391 7.65634 1.08843C7.86428 1.24646 8.01182 1.47095 8.07439 1.72453L8.42868 3.14167H15.2858C15.5889 3.14167 15.8796 3.26208 16.0939 3.4764C16.3083 3.69073 16.4287 3.98142 16.4287 4.28453V13.9988C16.4287 14.3019 16.3083 14.5926 16.0939 14.8069C15.8796 15.0213 15.5889 15.1417 15.2858 15.1417H2.71439C2.41129 15.1417 2.1206 15.0213 1.90627 14.8069C1.69194 14.5926 1.57153 14.3019 1.57153 13.9988Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f87cf5c455670672b23de0464e998971.svg";
export { ForwardRef as ReactComponent };